import { isDefinedArray, reduce } from "et3-type-guards";
import { memoize, orderBy } from "lodash";
import { computed, observable, runInAction } from "mobx";
import getKhattabatSelectsStore from "./selects-store";
import {
  T101CFilters,
  T101MFilters,
  TEt3PickerMultipleValue
} from "../../TypesNEW";
import { customIntersectWithPriority } from "../../helpers/et3-data-helper";
import getKhattabat101CStore from "./101c-stores/index";
import getKhattabat101MGeneralStore from "./101m-stores/general-101m-store";
import getKhattabat101MatchStore from "./101m-stores";
import getKhattabatSharedMessagingStore from "./messaging-stores/conversation-messaging-store";
import getKhattabat101CGeneralStore from "./101c-stores/101c-general-store";
class KhattabatFilterStore {
  filteredArray = observable.box<number[]>([]);
  filtered101MArray = observable.box<number[]>([]);
  searchingClients = observable.box<boolean>(false);
  searching1o1MMatches = observable.box<boolean>(false);
  filterSelectedTypes = observable.box<TEt3PickerMultipleValue>([]);
  filter1o1MSelectedTypes = observable.box<TEt3PickerMultipleValue>([]);

  setSearchingClients = (state: boolean) => {
    getKhattabatSelectsStore().initializeAndClearMarksStateWithClients(
      "clientPage"
    );
    runInAction(() => {
      this.searchingClients.set(state);
    });
  };

  setFilteredArray = (ids: number[]) => {
    runInAction(() => {
      this.filteredArray.set(ids);
    });
  };

  setSearching1o1MMatches = (state: boolean) => {
    getKhattabatSelectsStore().initializeAndClearMarksStateWithClients(
      "matchResultPage"
    );
    runInAction(() => {
      this.searching1o1MMatches.set(state);
    });
  };

  setFilterSelectedTypes = (types: TEt3PickerMultipleValue) => {
    runInAction(() => this.filterSelectedTypes.set(types));
  };

  setFiltered1o1MArray = (matchIDs: number[]) => {
    runInAction(() => {
      this.filtered101MArray.set(matchIDs);
    });
  };

  isActiveFilter = computed(() => {
    return isDefinedArray(this.filterSelectedTypes.get());
  });

  setFilterSelected101MTypes = (types: TEt3PickerMultipleValue) => {
    runInAction(() => this.filter1o1MSelectedTypes.set(types));
  };

  isActive1o1MFilter = computed(() => {
    return isDefinedArray(this.filter1o1MSelectedTypes.get());
  });

  isFilterCritereaHasBeenChosen = (criteria: T101CFilters) => {
    const currentSlectedCriterias = reduce(
      () => this.filterSelectedTypes.get(),
      []
    );
    return currentSlectedCriterias.some((selectedCriteria) => {
      return selectedCriteria.value === criteria;
    });
  };

  is1o1MFilterCritereaHasBeenChosen = (criteria: T101MFilters) => {
    const currentSelectedCriterias = reduce(
      () => this.filter1o1MSelectedTypes.get(),
      []
    );
    return currentSelectedCriterias.some((selectedCriteria) => {
      return selectedCriteria.value === criteria;
    });
  };

  handleFiltering = () => {
    const clientIds = getKhattabat101CGeneralStore().clientsIDs.get();

    //unread messages part
    let clientIdsForUnreadMessages: number[] =
      getKhattabat101CGeneralStore().allAvailableClientsIds.get();
    const isUnreadMessagesPresentInFilter =
      this.isFilterCritereaHasBeenChosen("unread_messages");
    if (isUnreadMessagesPresentInFilter) {
      clientIdsForUnreadMessages = clientIds.filter((id) =>
        getKhattabatSharedMessagingStore(
          getKhattabat101CStore(id).oneOOneCId.get()
        ).hasUnreadMessages.get()
      );
    }

    //no 102
    let clientIdsForNo102: number[] =
      getKhattabat101CGeneralStore().allAvailableClientsIds.get();
    const isNoActive102PresentInFilter =
      this.isFilterCritereaHasBeenChosen("no_one_o_two");
    if (isNoActive102PresentInFilter) {
      clientIdsForNo102 = clientIds.filter((id) =>
        getKhattabat101CStore(id).hasNoActiveOneOTwo.get()
      );
    }

    //expired Subscription
    let clientIdsForExpiredSubscription: number[] =
      getKhattabat101CGeneralStore().allAvailableClientsIds.get();
    const isExpiredSubscriptionInFilter =
      this.isFilterCritereaHasBeenChosen("expired");
    if (isExpiredSubscriptionInFilter) {
      clientIdsForExpiredSubscription = clientIds.filter(
        (id) => !getKhattabat101CStore(id).isVIPKhatabat.get()
      );
    }

    // is renewed is last 7 days
    let clientIdsForRenewedLastSevenDays: number[] =
      getKhattabat101CGeneralStore().allAvailableClientsIds.get();
    const isRenewedLastSevenDaysInFilter =
      this.isFilterCritereaHasBeenChosen("renewed");
    if (isRenewedLastSevenDaysInFilter) {
      clientIdsForRenewedLastSevenDays = clientIds.filter((id) => {
        const client101CStore = getKhattabat101CStore(id);
        const isRenewedInLastSevenDays = reduce(
          () => client101CStore.isRenewedInLastSevenDays.get(),
          false
        );
        if (isRenewedInLastSevenDays) {
          return id;
        }
      });
    }

    //intersection part
    const intersectionArray = customIntersectWithPriority(
      [
        clientIdsForUnreadMessages,
        clientIdsForNo102,
        clientIdsForExpiredSubscription,
        clientIdsForRenewedLastSevenDays
      ],
      []
    );

    const filteredClients = intersectionArray
      .map((id) =>
        getKhattabat101CGeneralStore()
          .clientsIDs.get()
          .find((clientId) => id === clientId)
      )
      .filter(Boolean); // Removes any undefined values if a client isn't found
    this.setFilteredArray(filteredClients);
    this.setSearchingClients(true);
  };

  handle1o1MFiltering = () => {
    const matchesIds =
      getKhattabat101MGeneralStore().getAllAvailableMatchesIds();
    //unread messages part
    let matchesIdsForUnreadMessages: number[] = matchesIds;
    const isUnreadMessagesPresentInFilter =
      this.is1o1MFilterCritereaHasBeenChosen("unread_messages");
    if (isUnreadMessagesPresentInFilter) {
      matchesIdsForUnreadMessages = matchesIds.filter((id) =>
        getKhattabatSharedMessagingStore(
          getKhattabat101MatchStore(id).conversationID.get()
        ).hasUnreadMessages.get()
      );
    }

    // one o one m highlighted
    let matchesIdsForOneOOneMHighlighted: number[] = matchesIds;
    if (this.is1o1MFilterCritereaHasBeenChosen("highlighted")) {
      matchesIdsForOneOOneMHighlighted = matchesIds.filter((id) =>
        getKhattabat101MatchStore(id).matchConversationIsHighlighted.get()
      );
    }

    // last login desc

    let matchesIdsForLastLoginDescending: number[] = matchesIds;
    const recentLoginInFilter =
      this.is1o1MFilterCritereaHasBeenChosen("recent_login");
    if (recentLoginInFilter) {
      matchesIdsForLastLoginDescending = orderBy(
        matchesIds,
        [(id) => getKhattabat101MatchStore(id).matchLastLogin.get()],
        ["desc"]
      );
    }

    //intersection part
    const intersectionArray = customIntersectWithPriority(
      [
        matchesIdsForUnreadMessages,
        matchesIdsForOneOOneMHighlighted,
        matchesIdsForLastLoginDescending
      ],
      recentLoginInFilter ? matchesIdsForLastLoginDescending : []
    );
    this.setFiltered1o1MArray(
      isDefinedArray(intersectionArray) ? intersectionArray : []
    );
    this.setSearching1o1MMatches(true);
  };

  resetFilters = () => {
    this.setFilterSelectedTypes([]);
    this.setFilteredArray([]);
    this.setSearchingClients(false);
    getKhattabatSelectsStore().initializeAndClearMarksStateWithClients(
      "clientPage"
    );
  };

  reset1o1MFilters = () => {
    this.setFilterSelected101MTypes([]);
    this.setFiltered1o1MArray([]);
    this.setSearching1o1MMatches(false);
    getKhattabatSelectsStore().initializeAndClearMarksStateWithClients(
      "matchResultPage"
    );
  };

  isSearchingClients = computed(() => {
    return this.searchingClients.get() || this.isActiveFilter.get();
  });

  isSearching1o1MMatches = computed(() => {
    return this.searching1o1MMatches.get() || this.isActive1o1MFilter.get();
  });

  update1o1MFilter = () => {
    const isActiveFilter =
      getKhattabatFilterStore().isSearching1o1MMatches.get();

    if (isActiveFilter) {
      getKhattabatFilterStore().handle1o1MFiltering();
    }
  };
}

export const getKhattabatFilterStore = memoize(
  () => {
    return new KhattabatFilterStore();
  },
  () => 1
);

export default getKhattabatFilterStore;
